// extracted by mini-css-extract-plugin
export default {"headerContainer":"goBackHeader_headerContainer__6yMaB","title":"goBackHeader_title__YeTjm"};